import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c949c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dynamic-component-demo-posts-tab" }
const _hoisted_2 = { class: "dynamic-component-demo-posts-sidebar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "dynamic-component-demo-post-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "dynamic-component-demo-post"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["innerHTML"]

import {Ref, ref} from "vue";

interface Post {
  id: number,
  title: string,
  img: string,
  content: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const posts: Array<Post>= [
        {
          id: 1,
          title: 'Doggo Ipsum',
          img: 'https://images.unsplash.com/photo-1593750606500-f0237a94ea1a?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
          content:
              '<p>Doggo ipsum heckin angery woofer super chub what a nice floof yapper doing me a frighten maximum borkdrive length boy pats, fat boi pupper pats shooberino very good spot. Sub woofer puggorino many pats what a nice floof boof heckin angery woofer smol borking doggo with a long snoot for pats sub woofer, maximum borkdrive wow very biscit heckin good boys and girls waggy wags h*ck. Boofers length boy pats such treat pats heck boofers, pupperino stop it fren heck very good spot wow very biscit.  Shoob I am bekom fat pupperino, dat tungg tho.</p>'
        },
        {
          id: 2,
          title: 'Hipster Ipsum',
          img: 'https://images.unsplash.com/photo-1516314774844-26f6888144e8?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
          content:
              '<p>Bushwick blue bottle scenester helvetica ugh, meh four loko. Put a bird on it lumbersexual franzen shabby chic, street art knausgaard trust fund shaman scenester live-edge mixtape taxidermy viral yuccie succulents. Keytar poke bicycle rights, crucifix street art neutra air plant PBR&B hoodie plaid venmo. Tilde swag art party fanny pack vinyl letterpress venmo jean shorts offal mumblecore. Vice blog gentrify mlkshk tattooed occupy snackwave, hoodie craft beer next level migas 8-bit chartreuse. Trust fund food truck drinking vinegar gochujang.</p>'
        },
        {
          id: 3,
          title: 'Cupcake Ipsum',
          img: 'https://images.unsplash.com/photo-1514077583608-aedd9ec18c40?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
          content:
              '<p>Icing dessert soufflé lollipop chocolate bar sweet tart cake chupa chups. Soufflé marzipan jelly beans croissant toffee marzipan cupcake icing fruitcake. Muffin cake pudding soufflé wafer jelly bear claw sesame snaps marshmallow. Marzipan soufflé croissant lemon drops gingerbread sugar plum lemon drops apple pie gummies. Sweet roll donut oat cake toffee cake. Liquorice candy macaroon toffee cookie marzipan.</p>'
        }
      ];
const selectedPost: Ref<null | Post> = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(posts, (post) => {
        return _createElementVNode("li", {
          key: post.id,
          class: _normalizeClass({
          'dynamic-component-demo-active': post === selectedPost.value
        }),
          onClick: ($event: any) => (selectedPost.value ? selectedPost.value = null : selectedPost.value = post)
        }, _toDisplayString(post.title), 11, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!selectedPost.value)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_5, " Click on a blog title to view it. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(selectedPost.value.title), 1),
            _createElementVNode("img", {
              src: selectedPost.value.img,
              alt: selectedPost.value.title
            }, null, 8, _hoisted_7),
            _createElementVNode("div", {
              innerHTML: selectedPost.value.content
            }, null, 8, _hoisted_8)
          ]))
    ])
  ]))
}
}

})